import React, { useEffect, useState } from "react";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
  TextField,
  Typography,
  Modal,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Stack,
  List,
  ListItem,
} from "@mui/material";

const MainBodyModalGrouped = ({
  openGrouped,
  handleCloseGrouped,
  id,
  title,
  repeatLastFilmListRequest,
  responseFilmList,
}) => {
  const [responseGroupedList, setResponseGroupedList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [localGrouped, setLocalGrouped] = useState([]);
  const [originalGroupedList, setOriginalGroupedList] = useState([]);

  useEffect(() => {
    if (!id || !openGrouped) return;
    fetchMovieData();
  }, [id, openGrouped, originalGroupedList]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (openGrouped) {
      setSelectedValue(""); // сбрасываем селект
      setLocalGrouped([]); // <--- СБРАСЫВАЕМ ВЫБРАННЫЕ ГРУППИРОВКИ
      getGroupedList();
    }
  }, [openGrouped]);

  async function getGroupedList() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/bundles/show`);
      setOriginalGroupedList(response.data.data);
      updateAvailableGroups(response.data.data, localGrouped); // фильтруем
    } catch (error) {
      console.error(error);
    }
  }

  function updateAvailableGroups(allGroups, selectedGroups) {
    const selectedIds = selectedGroups.map((entry) =>
      Number(Object.keys(entry)[0])
    );
    const filtered = allGroups.filter(
      (group) => !selectedIds.includes(group.id)
    );
    setResponseGroupedList(filtered);
  }

  const fetchMovieData = async () => {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/movie/${id}`);
      const movieData = response.data.data;
      if (movieData?.bundle) {
        setLocalGrouped(movieData.bundle);
        updateAvailableGroups(originalGroupedList, movieData.bundle);
      } else {
        setLocalGrouped([]);
        setResponseGroupedList(originalGroupedList);
      }
    } catch (error) {
      console.error("Ошибка при получении данных фильма:", error);
      setLocalGrouped([]);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleClickSendData = async (customId = selectedValue) => {
    if (!customId) return;
    try {
      const payload = {
        movie_id: id,
        bundle_id: customId,
      };

      const response = await Api.post(
        `${BASE_API_URL}/api/bundle/add`,
        payload
      );

      if (response.status === 200) {
        // alert("Группа добавлена успешно");
        repeatLastFilmListRequest();
        fetchMovieData();
      } else {
        alert("Ошибка при добавлении группы");
      }
    } catch (error) {
      console.error(error);
      alert("Произошла ошибка при добавлении группы");
    }
  };

  const handleClickRemoveData = async (customId = selectedValue) => {
    if (!customId) return;
    try {
      const payload = {
        movie_id: id,
        bundle_id: customId,
      };

      const response = await Api.post(
        `${BASE_API_URL}/api/bundle/remove`,
        payload
      );

      if (response.status === 200) {
        // alert("Группа удалена успешно");
        repeatLastFilmListRequest();
        fetchMovieData();
      } else {
        alert("Ошибка при удалении группы");
      }
    } catch (error) {
      console.error(error);
      alert("Произошла ошибка при удалении группы");
    }
  };

  return (
    <Modal open={openGrouped} onClose={handleCloseGrouped}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          maxWidth: 450,
          minWidth: 450,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Paper
          sx={{
            backgroundColor: "#E0F7FA",
            padding: 1,
            borderRadius: 2,
            marginBottom: 2,
            minHeight: 300,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" align="center" color="primary">
              {title}
            </Typography>
            <Typography variant="h6" align="center" color="primary">
              ID: {id}
            </Typography>
          </Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            {/* Левая часть: заголовки */}

            <Box
              sx={{
                position: "relative",
                border: "1px solid #90CAF9",
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: "#E0F7FA",
                mt: 1,
                mr: 1,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: "-10px",
                  left: "10px",
                  backgroundColor: "#E0F7FA",
                  paddingX: "4px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                Доступные группировки
              </Typography>

              <List dense>
                {responseGroupedList.map((item) => (
                  <ListItem
                    key={item.id}
                    onClick={() => {
                      handleClickSendData(item.id); // автоматически вызываем отправку при клике
                    }}
                    sx={{
                      display: "list-item",
                      listStyleType: "disc",
                      listStylePosition: "inside",
                      pl: 0,
                      cursor: "pointer",
                      "&:hover": {
                        color: "#1976d2",
                      },
                    }}
                  >
                    {item.name}
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* Правая часть: список с точками */}
            <Box
              sx={{
                position: "relative",
                border: "1px solid #90CAF9",
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: "#E0F7FA",
                mt: 1,
                minWidth: "185px",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: "-10px",
                  left: "10px",
                  backgroundColor: "#E0F7FA",
                  paddingX: "4px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                Выбранные группировки
              </Typography>

              <List dense>
                {localGrouped.map((entry) => {
                  const [bundleId, bundleName] = Object.entries(entry)[0]; // [1, "Для теста - 1"]
                  return (
                    <ListItem
                      key={bundleId}
                      onClick={() => handleClickRemoveData(Number(bundleId))}
                      sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        listStylePosition: "inside",
                        pl: 0,
                        cursor: "pointer",
                        "&:hover": {
                          color: "#d32f2f",
                        },
                      }}
                    >
                      {bundleName}
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          </Stack>
        </Paper>
        {/* <Paper
          sx={{
            backgroundColor: "#E0F7FA",
            padding: 1,
            borderRadius: 2,
            width: 440,
            overflowX: "auto",
          }}
        >
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Select
                      value={selectedValue}
                      onChange={handleSelectChange}
                      displayEmpty
                      fullWidth
                    >
                      <MenuItem value="">
                        <em>Выберите группировку</em>
                      </MenuItem>
                      {responseGroupedList.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper> */}

        {/* <Box sx={{ textAlign: "center", marginTop: 2 }}>
          <Button
            onClick={handleClickSendData}
            variant="contained"
            color="primary"
            disabled={!selectedValue}
            sx={{ mr: 1 }}
          >
            Отправить
          </Button>
          <Button
            onClick={handleClickRemoveData}
            variant="outlined"
            color="error"
            disabled={!selectedValue}
          >
            Удалить группу
          </Button>
        </Box> */}
      </Box>
    </Modal>
  );
};

export default MainBodyModalGrouped;
